// extracted by mini-css-extract-plugin
export default {"newsletterContainer":"Newsletter_newsletterContainer__EnIqo","formSection":"Newsletter_formSection__SDANe"};